import Morpheus from "@tm/morpheus"
import { handleAssetLoadProgress } from "./loadingProgress"

export function loadAssets(morpheus: Morpheus) {
    const loadAssetsPromise = morpheus.loadAssets(handleAssetLoadProgress)
    handleAssetLoadProgress([], morpheus.context.assetLoadCount)
    return loadAssetsPromise
}
